import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BccAccountPerformance from './components/Page';

const BccAccountPerformancePage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Brand Category Competition - Account Performance</h3>
      </Col>
    </Row>
    <Row>
      <BccAccountPerformance />
    </Row>
  </Container>
);

export default BccAccountPerformancePage;
